mod.modules.define("MyWatchlistsAndPortfolios", "BaseModule", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.SelectedTab = "Watchlists";
		this.SelectedListId = $("#watchlist_selector").val(params.watchlistId);

		this.addPlugin('Plugin-Paging');
		this.WatchlistPlugin = this.addPlugin('WatchlistModals');
	};

	fn.prototype.getContext = function() {
		return {
			SelectedTab: this.SelectedTab,
			SelectedListId: this.SelectedListId
		};
	};

	fn.prototype.events = {
		"#watchlist_selector": {
			"change": function(e, $el) {
				this.SelectedListId = $el.val();

				this.reload({
					PageIndex: 0
				});
			}
		},
		"a.editWatchlist": {
			"click": function(e, $el) {
				var SelectedListId = $("#watchlist_selector").val();
				this.WatchlistPlugin.goHome(SelectedListId);
			}
		},
		"[data-action='createwatchlist']": {
			"click": function(e, $el) {
				this.WatchlistPlugin.showModal("#createWatchlistModal", $("[data-type='mywatchlistsandportfolios']"));
			}
		}
	};

});